import React, { useState, useEffect } from "react";
import "@styles/components/ui/Cookies.scss";
import { Box, Typography, Button } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import CancelIcon from "@mui/icons-material/Cancel";

const Cookies = () => {
  const { t, i18n } = useTranslation();
  const isChinese = i18n.language === "hk";

  const [showCookies, setShowCookies] = useState(false);

  // ✅ component mount 時檢查 localStorage
  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (!accepted) {
      setShowCookies(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true"); // ✅ 儲存接受狀態
    setShowCookies(false);
  };

  return (
    showCookies && (
      <Box className="cookies-container">
        <Box className="title-container">
          <Typography className="title">
            <Trans i18nKey="global:cookies_title" />
          </Typography>
          <CancelIcon
            className="close-icon"
            onClick={() => setShowCookies(false)}
          />
        </Box>
        <Box className="content-container">
          <Typography
            className="message"
            dangerouslySetInnerHTML={{
              __html: t("global:cookies_message"),
            }}
          />
          <Box className="button-container">
            <Button className="loading-button" onClick={handleAccept}>
              <Trans i18nKey="global:cookies_accept" />
            </Button>
          </Box>
        </Box>
      </Box>
    )
  );
};

export default Cookies;
